import { render, staticRenderFns } from "./newWorkingTeamDetails.vue?vue&type=template&id=d814fbc4"
import script from "./newWorkingTeamDetails.vue?vue&type=script&lang=js"
export * from "./newWorkingTeamDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports